class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    
    this.rebuyReady = false;
    document.addEventListener('rebuy.ready', (evt) => {
      this.rebuyReady = true;
    });

    // Holds the single pending waitForElm('#tidio-chat') promise, so repeated drawer opens
    // reuse one MutationObserver instead of registering a new one each time (KEET-576).
    this.tidioChatWait = null;
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');

      const viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
      // Offset must match .drawer__inner width in component-cart-drawer.css (50rem / 500px)
      if (viewportWidth > 640) {
        const tidioChat = document.getElementById('tidio-chat');
        if (tidioChat)
          tidioChat.style.marginRight = '500px';
        else if (!this.tidioChatWait) {
          /*
           * Cache the pending wait so repeated opens share one observer instead of each
           * registering another -- that unbounded growth is the KEET-576 defect.
           *
           * Re-armed on a null resolve: Tidio is gated behind Secuvy consent, so "still absent
           * when the wait expires" usually just means the visitor is reading the banner, not
           * that Tidio will never load. Clearing the cache lets a later open start a fresh
           * bounded wait, which keeps the offset working for a visitor who consents slowly.
           * The guard still holds the invariant that matters: never more than one observer
           * live at a time, and every one of them tears itself down.
          */
          this.tidioChatWait = waitForElm('#tidio-chat').then(tidioChat => {
            if (!tidioChat) {
              this.tidioChatWait = null;
              return;
            }

            if (this.classList.contains('active'))
                tidioChat.style.marginRight = '500px';
          });
        }
      }
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    
    const tmp = this.querySelector('div[data-rebuy-id] > div')
    if (tmp) {
      setTimeout(() => {
        tmp.removeAttribute('inert');
      }, 500);
    }
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    

    const tidioChat = document.getElementById('tidio-chat');
    if (tidioChat) tidioChat.style.marginRight = '0px';
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  moveDrawerSections(toTemp, source) {
    const drawerSections = document.querySelector('.drawer__sections');
    const drawerSectionsTmp = document.querySelector('.drawer__sections-tmp');

    var elements = toTemp ? drawerSections.children : drawerSectionsTmp.children;
    for (const section of elements) {
      if (section.querySelector('div[data-rebuy-id]') && !this.rebuyReady) {
        continue;
      }
      toTemp ? drawerSectionsTmp.appendChild(section) : drawerSections.appendChild(section);
    }
  }

  renderContents(parsedState) {

    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;

    this.moveDrawerSections(true, 'renderContents')

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    
    this.moveDrawerSections(false, 'renderContents')

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

